// Filename builders for the aggregate leaderboard PDF + CSV exports.
// Centralised so both endpoints produce identical prefixes.

/**
 * Take the first {@link n} filename-safe characters of a competition
 * name. Punctuation (spaces, dashes, apostrophes, slashes, etc.) is
 * stripped so the output survives every OS filesystem, and the case is
 * preserved so "Landscape" reads better than "landscape" on disk.
 */
function safePrefix(name, n = 8) {
  const cleaned = (name || "").replace(/[^A-Za-z0-9]/g, "");
  return cleaned.slice(0, n) || "untitled";
}

/**
 * Build a filename like "aggregate_Landsca-UrbanRe-NaturePr" (no
 * extension) from the ordered list of competitions in the leaderboard.
 * Falls back to a comp-count summary when the joined name would exceed
 * ~120 chars — Windows tolerates 255 but shorter is friendlier when the
 * PDF ends up as an email attachment.
 */
export function aggregateFilenameStem(competitions) {
  if (!competitions?.length) return "aggregate";
  const parts = competitions.map((c) => safePrefix(c.competition_name, 8));
  const joined = parts.join("-");
  const stem = `aggregate_${joined}`;
  if (stem.length > 120) {
    return `aggregate_${competitions.length}comps`;
  }
  return stem;
}
